<template>
  <div>
      <b-container class="p-5">
        <p class="text-primary mb-0 font-size-20"> كيف حالك ؟ {{ clientInfo.full_name }} </p>
        <h3 class="text-primary font-weight-bold">أهلا بك فى منصة إبل</h3>
        <b-card class="bg-warning text-white iq-border-radius-10 mt-4">
          <p v-if="clientInfo.status === 'processing'" class="m-0 p-0 font-size-18 font-weight-bold">جاري مراجعة البيانات، سيتم التواصل معك فور الانتهاء</p>
          <p v-else-if="clientInfo.status === 'rejected'" class="m-0 p-0 font-size-18 font-weight-bold">لقد تم رفض البيانات التي قمت بتقديمها. لمعرفة السبب يرجى التواصل مع الإدارة أو تفقد بريدك الإلكتروني</p>
          <p v-else-if="clientInfo.status === 'suspended'" class="m-0 p-0 font-size-18 font-weight-bold">لقد تم إيقافك من قبل الإدارة. لمعرفة السبب يرجى التواصل مع الإدارة أو تفقد بريدك الإلكتروني</p>
        </b-card>
        <div class="d-flex justify-content-center align-items-center mt-5">
          <img :src="require('@/assets/images/error/image-empty.svg')">
        </div>
      </b-container>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import mainInfo from '@/mixins/mainInfo'
export default {
  components: {},
  mixins: [mainInfo],
  mounted () {
    core.index()
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
    this.getInfo('doctor')
    // if (clientInfo.status === 'accepted') this.$router.push({ name: 'doctorDashboard' })
  }
}
</script>
